import { Button } from '@/components/ui/button';
import type { HistoryItem } from '@/features/search-bar/types';
import { formatHistoryDate } from '@/features/search-bar/utils';
import Icon from '@/icons/icon';

export function HistoryItemRow({
    item,
    onClick,
    onRemove,
}: {
    item: HistoryItem;
    onClick: () => void;
    onRemove: (e: React.MouseEvent) => void;
}) {
    const subtitle = [
        item.startDate && item.endDate
            ? `${formatHistoryDate(item.startDate)} – ${formatHistoryDate(item.endDate)}`
            : null,
        item.adults > 0
            ? `${item.adults} adult${item.adults > 1 ? 's' : ''}`
            : null,
    ]
        .filter(Boolean)
        .join(' , ');

    return (
        <li
            onClick={onClick}
            className="flex cursor-pointer items-center gap-3 border-b border-gray-100 px-3 py-2 text-sm transition hover:bg-gray-50"
        >
            <Icon
                iconName="HistoryClock"
                className="h-6 w-6 shrink-0 stroke-gray-500"
            />
            <div className="min-w-0 flex-1">
                <div className="truncate font-medium text-gray-900">
                    {item.query}
                </div>
                <div className="text-xs text-gray-500">{subtitle}</div>
            </div>
            <Button
                variant="bare"
                type="button"
                onClick={onRemove}
                className="shrink-0 cursor-pointer rounded p-0.5 hover:bg-gray-200"
            >
                <Icon iconName="X" className="h-6 w-6 stroke-gray-500" />
            </Button>
        </li>
    );
}
